import * as React from 'react';
import SvgIcon from '../../SvgIcon';
const SvgHamburger = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M24.1 4.18a1.39 1.39 0 0 1-1.39 1.39H1.49A1.39 1.39 0 0 1 .1 4.18a1.39 1.39 0 0 1 1.39-1.39h21.22a1.39 1.39 0 0 1 1.39 1.39M24.1 12.08a1.39 1.39 0 0 1-1.39 1.39H1.49A1.39 1.39 0 0 1 .1 12.08a1.39 1.39 0 0 1 1.39-1.39h21.22a1.39 1.39 0 0 1 1.39 1.39M24.1 20.22a1.39 1.39 0 0 1-1.39 1.39H1.49A1.39 1.39 0 0 1 .1 20.22a1.39 1.39 0 0 1 1.39-1.39h21.22a1.39 1.39 0 0 1 1.39 1.39"
    }));
export default SvgHamburger;
